import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20lifestyle%20photography%20with%20neutral%20cream%20and%20sage%20green%20tones%2C%20scattered%20fashion%20accessories%20on%20a%20clean%20white%20marble%20surface%2C%20elegant%20flat%20lay%20composition%20with%20soft%20natural%20daylight%2C%20textured%20linen%20fabric%20background%2C%20editorial%20catalog%20aesthetic%2C%20warm%20atmospheric%20mood%2C%20high%20end%20product%20photography&width=1600&height=900&seq=hero-bg-gtbuy&orientation=landscape"
          alt="GTBuy Spreadsheet shopping intelligence lifestyle background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20 max-w-7xl mx-auto">
          <div className="flex-1 w-full pt-8 md:pt-14">
            <p className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-6">
              Shopping Intelligence
            </p>
            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight">
              GTBuy Spreadsheet
              <br />
              <span className="font-normal italic text-background-200">
                Compare, Track &amp;
              </span>
              <br />
              <span className="text-background-50">Shop Smarter</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-background-200 max-w-xl leading-relaxed">
              A data-driven spreadsheet system to compare products, track prices, and optimize online purchases across GTBuy Spreadsheet, Kakobuy Spreadsheet, and Superbuy Spreadsheet platforms.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center px-7 py-3 rounded-full bg-background-50 text-primary-800 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors"
              >
                Explore GTBuy Spreadsheet
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <Link
                to="/article/what-is-gtbuy-spreadsheet"
                className="inline-flex items-center justify-center px-7 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                Read Full Guide
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center w-full">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20a%20premium%20sneaker%20shoe%20on%20a%20clean%20cream%20background%2C%20soft%20diffused%20studio%20lighting%2C%20side%20angle%20view%2C%20modern%20fashion%20editorial%20style%2C%20subtle%20drop%20shadow%2C%20warm%20neutral%20tones%2C%20high%20end%20commercial%20product%20shot%2C%20textured%20paper%20backdrop&width=600&height=600&seq=hero-floating-product&orientation=squarish"
                alt="Premium product showcase"
                className="w-full max-w-md rounded-3xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-background-50/95 backdrop-blur-sm rounded-2xl p-4 shadow-sm">
                <p className="text-xs text-foreground-500 font-medium">Compare across</p>
                <p className="text-lg font-heading font-bold text-primary-700">14 Categories</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50 text-2xl opacity-60"></i>
      </div>
    </section>
  );
}